import { WebsiteElement } from '@/interfaces/element.interface';
import { ApiQueryParams, apiRequest } from '../Api';

export interface ReadWebsiteElementResponse {
  success: boolean;
  message: string;
  data: WebsiteElement;
}

export const readWebsiteElement = (
  elementId: string,
  params: ApiQueryParams
) =>
  apiRequest<void, ReadWebsiteElementResponse>({
    url: `/entities/read/${elementId}`,
    scope: 'element',
    method: 'GET',
    params,
  });

